/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * slider.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * Imprt swiper.
 */
import Swiper from "swiper/bundle";

/**
 * Imprt CSS.
 */
import "swiper/css/bundle";

/**
 * 共通スライダー
 *━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
const defaultSlider = () => {
	const option = {
		loop: true,
		speed: 1000,
		// autoplay: {
		// 	delay: 3000,
		// 	disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
		// },
		navigation: {
			nextEl: ".slider-arrow-next",
			prevEl: ".slider-arrow-prev",
		},
		pagination: {
			el: ".slider-default-pagination",
			clickable: true,
		},
	};

	const slider = new Swiper(".slider-default", option);
};

const mvSlider = () => {
	// if (window.matchMedia("(min-width: 600px)").matches) {
	// 	var centeredSlides = "false";
	// } else {
	// 	var centeredSlides = "ture";
	// }

	/**
	 * Setting - Thumbnail Slider - デフォルト
	 */
	const optionThumbnail = {
		loop: true,
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		speed: 2000,
	};
	const sliderThumbnail = new Swiper(".slider-mv-parse", optionThumbnail);

	const option = {
		loop: true,
		parallax: true,
		speed: 2000,
		autoplay: {
			delay: 2000,
			disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
		},
		thumbs: {
			swiper: sliderThumbnail,
		},
	};

	const slider = new Swiper(".slider-mv", option);
};

const fadeSlider = () => {
	/**
	 * Setting - Fade Slider - デフォルト
	 */
	const option = {
		loop: true,
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		speed: 2000,
		autoplay: {
			delay: 2000,
			disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
		},
	};

	/**
	 * Action - Fade Slider - デフォルト
	 */
	const slider = new Swiper(".slider-fade", option);
};

const thumbnaiSlider = () => {
	const body = window.document.body;
	const classList = body.classList;

	if ([...classList].some((className) => className.startsWith("share-"))) {
		/**
		 * Setting - Thumbnail Slider
		 */
		const optionThumbail = {
			slidesPerView: 4,
			spaceBetween: 10,
			grabCursor: true,
			breakpoints: {
				761: {
					slidesPerView: 9,
					spaceBetween: 20,
				},
			},
		};

		const sliderThumbnail = new Swiper(".slider__thumbnail", optionThumbail);

		/**
		 * Setting - Main Slider
		 */
		const optionMain = {
			effect: "fade",
			fadeEffect: {
				crossFade: true,
			},
			speed: 1000,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			},
			// navigation: {
			// 	nextEl: ".swiper-button-next",
			// 	prevEl: ".swiper-button-prev",
			// },
			thumbs: {
				swiper: sliderThumbnail,
			},
		};

		const sliderThumbnailMain = new Swiper(".slider__thumbnail__main", optionMain);
	}
};

const carouselSlider = () => {
	/**
	 * Setting - Carousel Slider - デフォルト
	 */
	const option = {
		slidesPerView: 2,
		spaceBetween: 5,
		centeredSlides: true,
		loop: true,
		speed: 1500,
		autoplay: {
			delay: 3000,
			pauseOnMouseEnter: true,
			// disableOnInteraction: false,
		},
		breakpoints: {
			// スライドの表示枚数：500px以上の場合
			640: {
				slidesPerView: 3,
				spaceBetween: 10,
			},
			760: {
				slidesPerView: 4,
				spaceBetween: 10,
			},
		},
		// pagination: {
		// 	el: ".swiper-pagination",
		// 	clickable: true,
		// },
	};

	/**
	 * Action - Carousel Slider - デフォルト
	 */
	const sliderCarousel = new Swiper(".slider-carousel", option);
};

const postSlider = () => {
	// すべてのslider-post要素を取得
	const sliderElements = document.querySelectorAll(".slider-post");

	// 各スライダー要素に対して処理を実行
	sliderElements.forEach((sliderElement) => {
		// スライドの数を確認
		const slides = sliderElement.querySelectorAll(".swiper-slide");
		if (slides.length <= 1) {
			// スライドが1個以下の場合はスライダー機能を無効化
			sliderElement.classList.add("slider-disabled");
			return;
		}

		/**
		 * Setting - post Slider - デフォルト
		 */
		const option = {
			slidesPerView: 2,
			spaceBetween: 15,
			loop: true,
			speed: 1000,
			autoplay: {
				delay: 3000,
				pauseOnMouseEnter: true,
			},
			breakpoints: {
				961: {
					slidesPerView: 3,
					spaceBetween: 60,
				},
				761: {
					slidesPerView: 3,
					spaceBetween: 30,
				},
			},
		};

		/**
		 * Action - post Slider - デフォルト
		 */
		new Swiper(sliderElement, option);
	});
};

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/*index: set */

const setSlider = () => {
	defaultSlider();
	mvSlider();
	fadeSlider();
	thumbnaiSlider();
	carouselSlider();
	postSlider();
};
export { setSlider };
